import React from 'react'
import PropTypes from 'prop-types'
import './CustomSelect.scss'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator'
import InfoIcon from '@material-ui/icons/Info'
import { makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(() => ({
  selectRoot: {
    width: '384px',
    height: '44px',
    margin: '8px 0',
    '&.Mui-disabled': {
      backgroundColor: '#E0E0E0',
      color: '#000'
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },
  iconRoot: {
    height: '20px'
  }
}))

export default function CustomSelect(props) {
  const classes = useStyles()
  const { position, propertyField, availableFieldsForSelection, isMandatoryField, isDragging, onDragOver, onDragStart, onDrop } = props
  const [isHovered, setHovered] = React.useState(false)

  const handleChange = event => {
    props.handleSelectChange(position, event)
    setHovered(false)
  }

  return (
    <div className="selectWrapper"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onDragOver={onDragOver(position)}
      onDragStart={onDragStart(position)}
      onDrop={onDrop(position)}
      draggable={true}
      style={{
        cursor: isDragging ? 'grabbing' : 'grab'
      }}
      data-testid="CustomSelect"
    >
      <div className="iconCustomSelect">
        {isHovered && <DragIndicatorIcon data-testid="customSelect_dragIcon"/>}
      </div>
      <div className="select">
        <Select
          value={propertyField.value}
          onChange={handleChange}
          disabled={isMandatoryField}
          inputProps={{ 'aria-label': 'Without label', 'data-testid': `customSelect_menu-${position}` }}
          variant="outlined"
          className={classes.selectRoot}
        >

          <MenuItem value="NA">- Hide -</MenuItem>
          {propertyField.key !== 'NA' &&
            <MenuItem value={propertyField.value}>{propertyField.key}</MenuItem>
          }
          {availableFieldsForSelection.map((field, index) => (
            <MenuItem key={index} value={field.value}>{field.key}</MenuItem>
          ))}
        </Select>
      </div>

      <div className="iconCustomSelect">
        {isMandatoryField && (
          <Tooltip title="This field cannot be removed" placement="top">
            <InfoIcon color="primary" className={classes.iconRoot} />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

CustomSelect.propTypes = {
  position: PropTypes.number,
  propertyField: PropTypes.object,
  availableFieldsForSelection: PropTypes.array,
  isMandatoryField: PropTypes.bool,
  handleSelectChange: PropTypes.func,
  isDragging: PropTypes.bool,
  onDragOver: PropTypes.func,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func
}
